import styled from 'styled-components';

export const StyledFooter = styled.footer`
  flex-shrink: 0;
  padding: 20px;
  background-color: #c45634;
`;

export const FooterText = styled.p`
  text-align: center;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 300;
`;
